import './PresentationDetailPage.css'

import { Tab } from 'material-ui/Tabs'
import { compose, withProps } from 'recompose'
import React from 'react'
import { withRouter } from 'react-router-dom'

import { trackEvent } from '../../app/ga'
import {
  getAppTitle,
  getChatCfg,
  getPresentation,
  getPresentationChatroom,
} from '../../app/selectors'
import PresentationChat from './PresentationChat'
import Msg from '../../components/Msg'
import PresentationNotes from './PresentationNotes'
import NavigationTabs from '../../components/NavigationTabs'
import PresentationContent from './PresentationContent'
import content from '../../content'

function PresentationDetailPage({ appTitle, presentation, chatCfg, chatroom }) {
  if (!presentation) {
    return null
  }
  const showChat = !!(chatCfg && chatroom)
  return (
    <NavigationTabs initialSelectedIndex={0}>
      <Tab label={<Msg id="PresentationDetail.tab.detail" />}>
        <PresentationContent presentation={presentation} />
      </Tab>
      <Tab
        label={<Msg id="PresentationDetail.tab.notes" />}
        onActive={() => trackEvent('notes', 'display', presentation.title)}
      >
        <PresentationNotes presentation={presentation} appTitle={appTitle} />
      </Tab>
      {showChat && (
        <Tab
          label={<Msg id="PresentationDetail.tab.chat" />}
          onActive={() => trackEvent('chat', 'display', presentation.title)}
        >
          <PresentationChat
            presentation={presentation}
            appId={chatCfg.appId}
            room={chatroom}
          />
        </Tab>
      )}
    </NavigationTabs>
  )
}

const withPageContent = withProps(ownProps => ({
  appTitle: getAppTitle(content),
  presentation: getPresentation(content, ownProps.match.params.id),
  chatroom: getPresentationChatroom(content, ownProps.match.params.id),
  chatCfg: getChatCfg(content),
}))

export default compose(withPageContent, withRouter)(PresentationDetailPage)



// WEBPACK FOOTER //
// ./src/containers/PresentationDetail/PresentationDetailPage.js